import {FunctionComponent} from "react";
import "./Prizes.scss";
import clsx from "clsx";
import SwiperCore, { Autoplay, EffectCoverflow, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

export interface IPrize {
    image: string;
    freeSpins: number;
    bonus: number;
    money: number;
}

interface IProps {
    prizes: IPrize[];
}

export const Prizes:FunctionComponent<IProps> = ({prizes = []}) => {
    const isMobile = window.innerWidth <= 768;

    const desktopView = (<div className={"prizesList"}>
        {prizes.map((prize, index) => (<div className={"prizeWrapper"} key={`prize-${index}`}>
            <img src={prize.image} className={"prizeImage"} alt={""} />
            <h3 className={clsx("freeSpins", "freeSpinsQuantity")}>{prize.freeSpins}</h3>
            <h3 className={clsx("freeSpins", "freeSpinsTitle")}>rotiri gratuite</h3>
            <h3 className={clsx("prizeBonus")}>+ {prize.bonus}% Bonus</h3>
            <h3 className={clsx("prizeBonus")}>până la {prize.money} RON</h3>
        </div>))}
    </div>);

    const mobileView = (<Swiper
        allowTouchMove={true}
        slidesPerView={1.4}
        slidesPerGroup={1}
        centeredSlides={true}
        draggable={true}
        className={clsx("prizesSwiper")}>

        {prizes.map((prize, index) => (
            <SwiperSlide key={index}>
                <div className={"prizeWrapper"}>
                    <img src={prize.image} className={"prizeImage"} alt={""} />
                    <h3 className={clsx("freeSpins", "freeSpinsQuantity")}>{prize.freeSpins}</h3>
                    <h3 className={clsx("freeSpins", "freeSpinsTitle")}>rotiri gratuite</h3>
                    <h3 className={clsx("prizeBonus")}>+ {prize.bonus}% Bonus</h3>
                    <h3 className={clsx("prizeBonus")}>până la {prize.bonus} RON</h3>
                </div>
            </SwiperSlide>))}
    </Swiper>);

    return (<>
        {isMobile ? mobileView : desktopView}
    </>);
}